import { createSlice } from '@reduxjs/toolkit';
import _isNil from 'lodash/isNil';
import { RootState } from '@Services/redux/Store';
import { IEntity } from './Interfaces';
import { initialEntityState } from './State';

const EntitySlice = createSlice({
    name: 'Entity',
    initialState: initialEntityState,
    reducers: {
        updateEntities(state, action) {
            state.entities = action.payload;
            state.selectedEntity = null;
        },
        setEntity(state, action) {
            state.selectedEntity = action.payload;
        },
        setIsEntityDrawerOpen(state, action) {
            state.isEntityDrawerOpen = action.payload;
        },
        updateSelectedEntityThumbnails(state, action) {
            if (
                state.selectedEntity.entity_version_id ===
                action.payload.entityVersionId
            ) {
                state.selectedEntity.thumbnails.push(action.payload.thumbnail);
            }
        },
        updateSelectedEntityMainImages(state, action) {
            if (
                state.selectedEntity.entity_version_id ===
                action.payload.entityVersionId
            ) {
                state.selectedEntity.mainImages.push(action.payload.main);
            }
        },
    },
});

export const EntityActions = EntitySlice.actions;

export const entitiesState = (state: RootState) => state.entity.entities;
export const selectedEntityState = (state: RootState): IEntity =>
    state.entity.selectedEntity;
export const isEntityDrawerOpenState = (state: RootState) =>
    !_isNil(state.entity.selectedEntity);

export default EntitySlice.reducer;
